import styled, { css } from "styled-components"
import {
  desktopTextStyles,
  tabletTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import Img from "gatsby-image"

export const Background = styled.div`
  background-color: var(--tricorn-black);
  width: 100vw;
`

export const StyledFluid = styled(Img)`
  margin-top: 64px;
  grid-column: 2 / -2;
  margin-bottom: 32px;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    margin: 96px 0px;
  }
`

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  margin-bottom: 64px;
  text-align: center;
  align-items: center;

  & h2, p {
    color: var(--dark-mode-body-grey);
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    grid-column: 8 / -1;
    text-align: left;
    justify-content: left;
    margin: 128px 0px;
  }
`

export const Title = styled.h2`
  ${mobileTextStyles.MobileHeadingTwoBold}
  color: var(--slate);
  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeBold}
  }
`

export const Body = styled.p`
  color: var(--body-text-grey);
  ${desktopTextStyles.BodyText18}
  margin-top: 24px;
  @media (min-width: ${Breakpoints.md}) {
    ${desktopTextStyles.BodyText16}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
  }
`

export const linkStyle = css`
  max-width: 282px;
  margin-top: 48px;
  justify-self: center;
  @media (min-width: ${Breakpoints.md}) {
    margin-top: 32px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    justify-self: left;
  }
`
